import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import EditBtnCellRenderer from './editBtnCellRenderer';
import SearchMenu from './searchMenu';
import { getUserRole, getUserDetails } from '../../../../services/common/util';
import { createAudit } from '../../../../services/clinicPortalServices/auditService';
import { auditEnums, serviceConstants } from '../../../../services/common/constants';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { fetchQcRanges } from '../../../../services/clinicPortalServices/qcRangeService';
import moment from 'moment';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';
import toastr from 'toastr';
import { Modal } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import QcSampleDetails from '../qcSampleGrid/qcSampleDetails';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class QcRangeGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quickFilterText: '',
            bulkCheckedIds: [],
            isBulkSelect: false,
            showCreateButton: false,
            showQcSampleCreationPopup: false,
            analyteIdsForQcSampleCreation: [],
            controlTypeForQcSampleCreation: '',
            columnDefs: [
                {
                    headerName: 'Actions', colId: 'actions',
                    minWidth: 150,
                    maxWidth: 150,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'editBtnCellRenderer'
                },
                {
                    headerName: 'Name',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.analyteId.name + ' - ' + params.data.controlType;
                    }
                },
                {
                    headerName: 'Analyte',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.analyteId.name;
                    }
                },
                {
                    headerName: 'Control Type',
                    minWidth: 150,
                    resizable: true,
                    field: 'controlType'
                },
                {
                    headerName: 'Result Type',
                    minWidth: 150,
                    resizable: true,
                    field: 'resultType'
                },
                {
                    headerName: 'Minimum Valid Range',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue && params.data.sdValue) {
                            return Number(params.data.targetValue) - Number(params.data.sdValue) * 2;
                        }
                    }
                },
                {
                    headerName: '- 10% Range',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue && params.data.sdValue) {
                            return Number(params.data.targetValue) - Number(params.data.sdValue);
                        }
                    }
                },
                {
                    headerName: 'Target Value',
                    minWidth: 150,
                    resizable: true,
                    field: 'targetValue'
                },
                {
                    headerName: '+ 10% Range',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue && params.data.sdValue) {
                            return Number(params.data.targetValue) + Number(params.data.sdValue);
                        }
                    }
                },
                {
                    headerName: 'Maximum Valid Range',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue && params.data.sdValue) {
                            return Number(params.data.targetValue) + Number(params.data.sdValue) * 2;
                        }
                    }
                },
                {
                    headerName: 'SD',
                    minWidth: 150,
                    resizable: true,
                    field: 'sdValue'
                },
                {
                    headerName: 'Result Choices',
                    minWidth: 150,
                    resizable: true,
                    field: 'resultChoices'
                },
                {
                    headerName: 'Valid Values',
                    minWidth: 150,
                    resizable: true,
                    field: 'validValues'
                },
                {
                    headerName: 'Creation Date',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return moment
                            .tz(params.data.createdAt, serviceConstants.SYSTEM_TIME_ZONE)
                            .format('MM/DD/YYYY hh:mm:ss A');
                    }
                },
                {
                    headerName: 'Created By',
                    minWidth: 150,
                    resizable: true,
                    field: 'createdBy'
                }
            ],
            components: {
                editBtnCellRenderer: EditBtnCellRenderer
            },
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            context: { componentParent: this }
        };
    }

    autoFitActions = (params) => {

        const api = (params && params.api) || this.gridApi;

        if (api && api.autoSizeColumns) setTimeout(() => { try { api.autoSizeColumns(['actions'], false); } catch (e) { /* ignore */ } }, 60);

    };


    onGridReady = (params) => {
        this.gridApi = params.api;

        this.loadGridData();
    };

    loadGridData = () => {
        fetchQcRanges().then((res) => {
            this.setState({ rowData: res.data });
        });
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    clearFilter = () => {
        this.gridApi.setFilterModel(null);
        this.setState({ quickFilterText: '' });
        document.getElementById('reset-form').value = '';
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: 'QC_Range_Grid_' + moment().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx',
            sheetName: 'QC Ranges'
        });
        const userData = JSON.parse(getUserDetails());
        const auditData = {
            identifier: auditEnums.IDENTIFIERS.ExportRecord,
            event_type: auditEnums.EVENTTYPES.QcRangeGridExported,
            user_id: userData._id,
            user_name: userData.user_name + ' (' + userData.role + ')',
            update_string: auditEnums.EVENTTYPES.QcRangeGridExported
        };
        createAudit(auditData);
    };

    onBtnBulkSelect = () => {
        if (this.state.isBulkSelect) {
            this.setState({ bulkCheckedIds: [], showCreateButton: false });
        }
        this.setState({ isBulkSelect: !this.state.isBulkSelect });
        this.gridApi.refreshCells();
    };

    handleBulkChecked = (id) => {
        let showCreateButton = false;
        let { bulkCheckedIds } = this.state;
        if (bulkCheckedIds.includes(id)) {
            bulkCheckedIds = bulkCheckedIds.filter((x) => x !== id);
        } else {
            bulkCheckedIds.push(id);
        }
        let controlTypes = [];
        this.gridApi.forEachNode((rowNode, index) => {
            if (bulkCheckedIds.includes(rowNode.data._id) && !controlTypes.includes(rowNode.data.controlType)) {
                controlTypes.push(rowNode.data.controlType);
            }
        });
        if (controlTypes.length === 1 && bulkCheckedIds.length > 1) {
            showCreateButton = true;
        }
        if (!showCreateButton && bulkCheckedIds.length > 1) {
            toastr.warning(
                'You must choose same control type QC Range to create QC Sample, please unselect and try again.'
            );
        }
        this.setState({
            bulkCheckedIds: bulkCheckedIds,
            showCreateButton: showCreateButton
        });
        this.gridApi.refreshCells();
    };

    onBtnCreateQcSample = () => {
        let analyteIds = [];
        let controlTypeForQcSampleCreation = '';
        this.gridApi.forEachNode((rowNode, index) => {
            if (this.state.bulkCheckedIds.includes(rowNode.data._id)) {
                analyteIds.push(rowNode.data.analyteId._id);
                controlTypeForQcSampleCreation = rowNode.data.controlType;
            }
        });
        this.setState({
            showQcSampleCreationPopup: true,
            analyteIdsForQcSampleCreation: analyteIds,
            controlTypeForQcSampleCreation: controlTypeForQcSampleCreation
        });
    };

    handleCloseQcSampleCreationPopup = () => {
        this.setState({ showQcSampleCreationPopup: false });
    };

    render() {
        let columnDefs = /salesperson|audit|salesadmin/.test(getUserRole().toLowerCase())
            ? this.state.columnDefs.filter((x) => x.headerName !== 'Actions')
            : this.state.columnDefs;
        return (
            <div className="clinic-contain">
                <SearchMenu
                    onFilterTextChange={this.onFilterTextChange}
                    clearFilter={this.clearFilter}
                    onBtnExport={this.onBtnExport}
                    context={this.state.context}
                    onBtnBulkSelect={this.onBtnBulkSelect}
                    onBtnCreateQcSample={this.onBtnCreateQcSample}
                    isBulkSelect={this.state.isBulkSelect}
                    showCreateButton={this.state.showCreateButton}
                />
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 250px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    onGridReady={this.onGridReady}
                                    onFirstDataRendered={this.autoFitActions}
                                    onRowDataUpdated={this.autoFitActions}
                                    rowData={this.state.rowData}
                                    pagination={true}
                                    paginationAutoPageSize={true}
                                    components={this.state.components}
                                    context={this.state.context}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.showQcSampleCreationPopup}
                    onHide={this.handleCloseQcSampleCreationPopup}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Add QC Sample</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <QcSampleDetails
                            context={this.state.context}
                            handleClose={this.handleCloseQcSampleCreationPopup}
                            analyteIds={this.state.analyteIdsForQcSampleCreation}
                            controlType={this.state.controlTypeForQcSampleCreation}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}

export default QcRangeGrid;
